// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.pagination-container::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}
.pagination-container .pagination-row {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.pagination-container .pagination-controls {
  display: flex;
  align-items: center;
  gap: 16px;
}
.pagination-container .pagination-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
  cursor: pointer;
}
.pagination-container .pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.pagination-container .pagination-btn .icon-wrapper {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ebedf2;
  border-radius: 50%;
}
.pagination-container .pagination-btn img {
  width: 16px;
  height: 16px;
}
.pagination-container .page-numbers {
  display: flex;
  gap: 8px;
}
.pagination-container .page-numbers span {
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
}
.pagination-container .page-numbers span.active {
  background-color: #ebedf2;
  font-weight: bold;
}
.pagination-container .pagination-info {
  display: flex;
  align-items: center;
  gap: 16px;
}
.pagination-container .pagination-info .page-size-dropdown {
  background-color: #f4f5f8;
  border: none;
  border-radius: 4px;
  padding: 8px;
  font-family: Cairo, sans-serif;
  font-size: 14px;
  color: #868aa8;
}
.pagination-container .pagination-info .display-info {
  color: #575962;
  font-family: Cairo, sans-serif;
  font-size: 14px;
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/pagination/pagination.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EAEA,iCAAA;EACA,qBAAA;AAAJ;AAEI;EACE,aAAA;EACA,QAAA;EACA,SAAA;AAAN;AAGI;EACE,oBAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AADN;AAII;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAFN;AAKI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;AAHN;AAKM;EACE,YAAA;EACA,mBAAA;AAHR;AAMM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;AAJR;AAOM;EACE,WAAA;EACA,YAAA;AALR;AASI;EACE,aAAA;EACA,QAAA;AAPN;AASM;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AAPR;AASQ;EACE,yBAAA;EACA,iBAAA;AAPV;AAYI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAVN;AAYM;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,8BAAA;EACA,eAAA;EACA,cAAA;AAVR;AAaM;EACE,cAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;AAXR","sourcesContent":[".pagination-container {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    overflow-x: auto;         \n    overflow-y: hidden;\n    white-space: nowrap;\n\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n\n    &::-webkit-scrollbar {\n      display: none;\n      width: 0;\n      height: 0;\n    }\n\n    .pagination-row {\n      display: inline-flex;\n      align-items: center;\n      justify-content: space-between;\n      width: 100%;\n    }\n  \n    .pagination-controls {\n      display: flex;\n      align-items: center;\n      gap: 16px;\n    }\n  \n    .pagination-btn {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background-color: transparent;\n      border: none;\n      cursor: pointer;\n  \n      &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n      }\n  \n      .icon-wrapper {\n        width: 36px;\n        height: 36px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-color: #ebedf2;\n        border-radius: 50%;\n      }\n  \n      img {\n        width: 16px;\n        height: 16px;\n      }\n    }\n  \n    .page-numbers {\n      display: flex;\n      gap: 8px;\n  \n      span {\n        cursor: pointer;\n        padding: 4px 8px;\n        border-radius: 4px;\n  \n        &.active {\n          background-color: #ebedf2;\n          font-weight: bold;\n        }\n      }\n    }\n  \n    .pagination-info {\n      display: flex;\n      align-items: center;\n      gap: 16px;\n  \n      .page-size-dropdown {\n        background-color: #f4f5f8;\n        border: none;\n        border-radius: 4px;\n        padding: 8px;\n        font-family: Cairo, sans-serif;\n        font-size: 14px;\n        color: #868aa8;\n      }\n  \n      .display-info {\n        color: #575962;\n        font-family: Cairo, sans-serif;\n        font-size: 14px;\n        font-weight: 400;\n      }\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
